<ng-template #translatedContent let-translation="translation">
  <div class="translation">
    <div class="translatable-field">
      <mat-form-field>
        <mat-label>{{'general.title' | translate}}</mat-label>
        <input [(ngModel)]="translation.appTitle" matInput>
      </mat-form-field>
      <mat-icon [matTooltip]="'dynamicContent.translateFromMain' | translate" *ngIf="translation.language !== 'de'"
                (click)="translateText(translation, translation.language, 'appTitle')">translate</mat-icon>
      <div *ngIf="translation.language !== 'de'" class="disclaimer">{{'general.deeplDisclaimer' | translate}}</div>
    </div>
  </div>
</ng-template>

<h1>ibexsmart Applikationen > {{getTitle()}}</h1>

<h2>{{ 'packages.ibextouch.general' | translate }}</h2>
<div class="icon"><icon-selector *ngIf="superadmin" [(model)]="item" type="new" key="iconOverride" variant="blank"></icon-selector></div>
<mat-form-field [style.width]="'100%'">
  <mat-label>{{'general.remark' | translate}}</mat-label>
  <input [(ngModel)]="item.remark" matInput>
</mat-form-field>
<div class="checkboxes">
  <ibex-checkbox [title]="'packages.installedApps.securedApp' | translate" *ngIf="superadmin" [checked]="item.isSecured" (click)="item.isSecured = $event.val"></ibex-checkbox>
  <ibex-checkbox [title]="'packages.installedApps.skipOnlyChild' | translate" *ngIf="superadmin" [checked]="item.skipWhenOnlyChild" (click)="item.skipWhenOnlyChild = $event.val"></ibex-checkbox>
  <ibex-checkbox [title]="'packages.installedApps.mobileDisabled' | translate" [checked]="item.mobileDisabled" (click)="item.mobileDisabled = $event.val"></ibex-checkbox>
</div>
<div class="timing">
  <day-month-input (onChange)="item.from = $event.value._d" key="from" translationPrefix="packages.images" [value]="item.from" globalVariable
                   [targetObject]="item" fieldName="from"></day-month-input>
  <day-month-input (onChange)="item.to = $event.value._d" key="to" translationPrefix="packages.images" [value]="item.to" globalVariable
                   [targetObject]="item" fieldName="to"></day-month-input>
  <button mat-icon-button (click)="clearInterval()">
    <mat-icon>delete</mat-icon>
  </button>
</div>


<ng-container *ngIf="item.translations.length === 1">
  <ng-container *ngTemplateOutlet="translatedContent;context:{ translation: item.translations[0] }"></ng-container>
</ng-container>

<ng-container *ngIf="item.translations.length > 1">
  <h2 class="translation-header">
    <span>{{'general.translations' | translate}}</span>
    <div>
      <ibex-checkbox *ngFor="let translation of item.translations" [title]="'general.languages.' + translation.language | translate"
                     [checked]="!translation.hidden" (click)="translation.hidden = !$event.val"></ibex-checkbox>
    </div>
  </h2>
  <mat-tab-group>
    <mat-tab *ngFor="let translation of item.translations" [label]="'general.languages.' + translation.language | translate" [disabled]="translation.hidden">
      <ng-container *ngTemplateOutlet="translatedContent;context:{ translation }"></ng-container>
    </mat-tab>
  </mat-tab-group>
</ng-container>
<code-area *ngIf="superadmin" [options]="codeEditorOptions" [parent]="item" [value]="item.detail" key="detail" type="json"></code-area>
